import React, { Component } from 'react'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import VendorCOAListPageUI from './VendorCOAListPageUI.js'

class VendorCOAListPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      chartOfAccountList: null,
      selectedList: null,
      unSelectedList: null,
      updateMode: false,
      updatingCOA: null
    }
  }

  render() {
    return (
      <VendorCOAListPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        chartOfAccountList={this.state.chartOfAccountList}
        updateMode={this.state.updateMode}
        selectedList={this.state.selectedList}
        unSelectedList={this.state.unSelectedList}
        updatingCOA={this.state.updatingCOA}
        // events
        onRefreshClick={this.onRefreshClick}
        onUpdateClick={this.onUpdateClick}
        onCancelClick={this.onCancelClick}
        onSelect={this.onSelect}
        onUnSelect={this.onUnSelect}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getChartOfAccounts(context)
  }

  getChartOfAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/chartOfAccounts`,
      cacheKey: CacheKeys.ChartOfAccounts(),
      callback: this.getChartOfAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getChartOfAccountsCallback = (response) => {
    this.setState({errorList: response.errorList, chartOfAccountList : response.chartOfAccountList})
  }

  onUpdateClick = (event) => {
    let selectedList = this.state.chartOfAccountList.filter(coa => coa.vendorPaymentEnabled)
    let unSelectedList = this.state.chartOfAccountList.filter(
      coa => !coa.vendorPaymentEnabled && (coa.coaCategoryCode === 'expense' || coa.coaCategoryCode === 'assets')
    )
    this.setState({updateMode: true, selectedList: selectedList, unSelectedList: unSelectedList})
  }

  onCancelClick = () => {
    this.setState({updateMode:false, errorList: null})
  }

  onSelect = (event) => {
    let coa = event.target.getAttribute('data-row-id')
    this.setState({updatingCOA: coa})
    RestApiUtils.post(this.props.context,
      `/api/su/vendorPayments/chartOfAccounts`,
      this.onSelectCallback, {
        chartOfAccountCode: coa
      }
    )
  }

  onSelectCallback = (response) => {
    console.log(response);
    CacheManager.removeObject(CacheKeys.ChartOfAccounts())
    let selectedList = response.chartOfAccountList.filter(coa => coa.vendorPaymentEnabled)
    let unSelectedList = response.chartOfAccountList.filter(
      coa => !coa.vendorPaymentEnabled && (coa.coaCategoryCode === 'expense' || coa.coaCategoryCode === 'assets')
    )
    this.setState({updatingCOA: null, chartOfAccountList : response.chartOfAccountList,
      selectedList: selectedList, unSelectedList: unSelectedList})
  }

  onUnSelect = (event) => {
    let coa = event.target.getAttribute('data-row-id')
    this.setState({updatingCOA: coa})
    RestApiUtils.delete(this.props.context,
      `/api/su/vendorPayments/chartOfAccounts`,
      this.onSelectCallback, {
        chartOfAccountCode: coa
      }
    )
  }

  onRefreshClick = () => {
    CacheManager.removeObject(CacheKeys.ChartOfAccounts())
    this.setState(
      {
        chartOfAccountList: null,
        errorList: null,
      }, this.getChartOfAccounts(this.props.context)
    )
  }
}

export default VendorCOAListPageSF
